<template>
  <div
    class="select-m-wrapper"
    :class="{ native: isNative }"
    data-t="m-select-sorting"
  >
    <StSelect
      v-if="isNative"
      v-model="selectedOption"
      :items="sortOptions"
      size="s"
      is-native
    />
    <template v-else>
      <StIcon class="select-icon" name="sorting" :size="20" />
      <select
        v-model="selectedOption"
        class="m-select"
        data-t="native-select-4zo0"
      >
        <option
          v-for="option in sortOptions"
          :key="option.id"
          :value="option.id"
          data-t="value-{{ option.id }}"
        >
          {{ option.title }}
        </option>
      </select>
    </template>
  </div>
</template>

<script setup lang="ts">
const { isNative } = defineProps<{
  isNative?: boolean
}>()

const selectedOption = defineModel<string>({ required: true })

const { sortOptions } = useSelectSorting()
</script>

<style scoped>
.select-m-wrapper {
  position: relative;

  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: var(--spacing-075);

  background: var(--background-secondary, #2d2d39);
  border-radius: var(--border-radius-100, 8px);

  &.native {
    padding: 0;
  }
}

.m-select {
  position: absolute;
  inset: 0;
  opacity: 0;
}
</style>
